import Vue from 'vue'
import store from '@/store'

const check = (el, binding) => {
  const value = binding.value
  const auths = store.getters.authInfo || []
  if (auths.includes(value)) {
    Vue.prototype.$nextTick(() => {
      el.parentNode && el.parentNode.removeChild(el)
    })
  }
}

// 注册一个全局自定义指令 `v-auth`
Vue.directive('auth', {
  inserted: (el, binding) => {
    check(el, binding)
  },

  update: (el, binding) => {
    check(el, binding)
  }
})
